import React from 'react';

import currencyFormatter from 'currency-formatter';

import { Stack, Typography } from '@mui/material';

import BookingCancelledToggle from '~/components/Refund/BookingCancelledToggle';
import TourCancellationWarning from '~/components/Refund/TourCancellationWarning';
import VccBalanceUpdateToggle from '~/components/Refund/VccBalanceUpdateToggle';

import { Refund } from './NewModal';

type Props = {
  handleFlagChange: () => void;
  tmpValue: (key) => number;
  refund: Refund;
};

function PartialCalculatedRefundVariant({ refund, tmpValue, handleFlagChange }: Props) {
  const amount = currencyFormatter.format(tmpValue('amount'), {
    code: refund.currency_code,
    precision: 2,
  });
  const shouldDisallowTourCancellation = refund.is_tour && refund.is_tour_with_active_optional_extras;

  return (
    <Stack id="PartialCalculatedRefundVariant" direction="column" spacing={2}>
      <Stack direction="row">
        <Typography pr={1}>Refund Amount to Customer:</Typography>
        <Typography component="span" fontWeight="bold" data-cy="refund-amount-to-customer">
          {amount}
        </Typography>
      </Stack>
      <Stack direction="column">
        <Typography pr={2}>Refund Policies:</Typography>
        <ul>
          {refund.refund_policies.map((policy) => (
            <li key={policy}>
              <Typography variant="subtitle1">{policy}</Typography>
            </li>
          ))}
        </ul>
      </Stack>
      {refund.is_subscription && (
        <Stack direction="row">
          <Typography pr={1}>Pro rata refund for the remainder of the annual subscription:</Typography>
          <Typography component="span" fontWeight="bold">
            {currencyFormatter.format(refund.pro_rata_subscription_refund_amount, {
              code: refund.currency_code,
              precision: 2,
            })}
          </Typography>
        </Stack>
      )}
      {!refund.is_subscription && (
        <>
          <TourCancellationWarning shouldDisallowTourCancellation={shouldDisallowTourCancellation} />
          {!shouldDisallowTourCancellation && (
            <BookingCancelledToggle handleFlagChange={handleFlagChange} mark_cancelled={refund.mark_cancelled} />
          )}
          <VccBalanceUpdateToggle handleFlagChange={handleFlagChange} update_vcc_balance={refund.update_vcc_balance} />
        </>
      )}
    </Stack>
  );
}

export default PartialCalculatedRefundVariant;
